type EvaluationFinalResponse = {
  formatted?: Record<string, unknown>;
  supplied?: Record<string, unknown> & { meta?: Record<string, unknown> };
};

export const getRerunFormData = (response?: EvaluationFinalResponse | null) => {
  if (!response) return {};
  const data = response.formatted
    ? { ...response.supplied, ...response.formatted }
    : {};
  return data;
};

export const evaluationHasMetaFormData = (response?: EvaluationFinalResponse | null) => (
  Boolean(response?.supplied && typeof response.supplied.meta === 'object' && response.supplied.meta !== null)
);

/**
 * Whether `redirectPath` is a same-origin, absolute path safe to redirect a browser to —
 * guards against open-redirect via a `redirectTo` query param. Mirrors
 * `RerunApplicationView`'s `isPermittedInternalRedirectPath` (kept as a separate copy here
 * rather than a shared import so this view's behavior stays independent of the
 * application-rerun flow).
 */
export const isPermittedInternalRedirectPath = (redirectPath: string): boolean => {
  if (!redirectPath.startsWith('/') || redirectPath.startsWith('//')) {
    return false;
  }

  try {
    return new URL(redirectPath, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
};
